import { render, staticRenderFns } from "./ProgramaPage.vue?vue&type=template&id=a983fac6"
import script from "./ProgramaPage.js?vue&type=script&lang=js&external"
export * from "./ProgramaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports